import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, Observable, of, tap } from 'rxjs';
import { CreateLead } from '../../Models/createLead';
import { DatosGenerales } from '../../Models/datosGenerales';
import { LeadResponse } from '../../Models/leadResponse';
import { getSessionId } from '../../helpers/storageUtils';
import { handleHttpError, handleLeadCreationResponse } from '../../motos/utils/lead-response-handler.utils';
import { LeadsService } from '../../services/Leads/leads.service';
import { ExceptionService } from '../../services/excepciones/exception.service';
import { WebMPlayerComponent } from "../../shared/components/web-mplayer/web-mplayer.component";
import { selectData } from '../../storage/Lead/data.selectors';
import { BannerAppComponent } from '../banner-app/banner-app.component';

@Component({
  selector: 'app-loader',
  standalone: true,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  imports: [BannerAppComponent, WebMPlayerComponent]
})
export class LoaderComponent implements OnInit {
  codAsesor: string = '';
  IdBitacora: string = '';
  parametro: string = '';
  sessionId: string = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;
  leadResponse: LeadResponse | null = null;
  datosLead: CreateLead | undefined = undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private leadsService: LeadsService,
    private exceptionService: ExceptionService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
  }

  ngOnInit(): void {
    this.sessionId = getSessionId().toString();

    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe(params => {
      this.codAsesor = params['codigoAsesor'] || '';
      console.log('Código Asesor en Loader:', this.codAsesor);
    });

    this.datosGenerales$
      .subscribe(
        (data) => {
          this.datosGenerales = data;
        }
      );

    this.datosLead = this.datosGenerales?.Lead;


    if (this.datosGenerales?.LeadResponse?.data?.Id) {
      if (this.datosLead) {
        // Create a copy to avoid mutating the immutable store object
        this.datosLead = { ...this.datosLead };
        this.datosLead.lead_id = this.datosGenerales.LeadResponse.data.Id;
      }
    }

    if (this.datosLead) {
      this.leadsService
        .postCrearLeads(this.datosLead, this.sessionId)
        .pipe(
          tap((data) => (this.leadResponse = data as any)),
          catchError((error) => {
            const processedError = handleHttpError(error);
            return of(processedError as any);
          }),
        )
        .subscribe((response: any) => {
          if (response) {
            handleLeadCreationResponse(
              response as any,
              this.router,
              this.store,
              this.codAsesor,
              this.leadsService,
              this.exceptionService,
              this.sessionId,
              this.datosLead,
            );
          }
        });
    } else {
      console.error('datosLead is undefined');
    }

  }

  navegar() {
    if (this.codAsesor === undefined || this.codAsesor === '') {
      this.router.navigate(['/ruta']);
    } else {
      this.router.navigate(['/ruta'], { queryParams: { codigoAsesor: this.codAsesor } });
    }
  }
}
